import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { AbstractControl, ControlValueAccessor, Validator, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  standalone: false,
  selector: 'input[mas-postcode-nl][ngModel]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PostcodeNlDirective),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PostcodeNlDirective),
      multi: true
    }
  ]
})
export class PostcodeNlDirective implements ControlValueAccessor, Validator {
  private _validateRegExp: RegExp;
  private _allowRegExp: RegExp;
  private _value: string;

  constructor(private _renderer: Renderer2, private _elementRef: ElementRef) {
    this._validateRegExp = new RegExp('^([1-9][0-9]{3})\\s*([A-Za-z]{2})\\s*$');
    this._allowRegExp = new RegExp('[0-9 a-zA-Z]');
    this._value = '';
  }

  get value(): string {
    return this._value;
  }

  set value(val: string) {
    if (this.value !== val) {
      this._value = val;
      this._onChange(val);
    }
  };

  writeValue(val: string): void {
    if (this.value !== val) {
      this._value = val;
      this._renderer.setProperty(this._elementRef.nativeElement, 'value', val);
    }
  }

  private _onChange = (_: any) => { };
  registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }

  private _onTouched = () => { };
  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  validate(control: AbstractControl) {
    const value = String(control.value);
    if (value.length > 0 && this._validateRegExp.test(value) === false) {
      return { 'invalidPostcode': { value } };
    }
    return null;
  }

  @HostListener('input', ['$event'])
  onInput(e) {
    const event = e || window.event;
    this.value = String(event.target['value']);
  }

  @HostListener('keypress', ['$event'])
  onKeypress(e) {
    const event = e || window.event;

    let char: string;
    if (event.which == null) {
      char = String.fromCharCode(event.keyCode);    // old IE
    } else if (event.which !== 0 && event.charCode !== 0) {
      char = String.fromCharCode(event.which);	  // All others
    } else {
      return true;
    }

    if (this._allowRegExp.test(char) === false) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }

  @HostListener('blur')
  onBlur() {
    this._onTouched();

    if (this._validateRegExp.test(this.value)) {
      const parsedValue = this.value.toUpperCase().replace(this._validateRegExp, '$1 $2');
      if (this.value !== parsedValue) {
        this.value = parsedValue;
        this._renderer.setProperty(this._elementRef.nativeElement, 'value', this.value);
      }
    }
  }
}
